import { render, staticRenderFns } from "./del_complete.vue?vue&type=template&id=dfdc1320&lang=pug&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dfdc1320')) {
      api.createRecord('dfdc1320', component.options)
    } else {
      api.reload('dfdc1320', component.options)
    }
    module.hot.accept("./del_complete.vue?vue&type=template&id=dfdc1320&lang=pug&", function () {
      api.rerender('dfdc1320', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/payment/del_complete.vue"
export default component.exports